function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint semi:            ["error", "never"]*/

/* eslint arrow-parens:    ["error", "as-needed"]*/

/* eslint key-spacing:     ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
import React, { Component } from 'react';
import { ordinal } from '@engine/lib/utility/ordinal';

var ReminderSetting = /*#__PURE__*/function (_Component) {
  _inherits(ReminderSetting, _Component);

  var _super = _createSuper(ReminderSetting);

  function ReminderSetting(props) {
    var _this;

    _classCallCheck(this, ReminderSetting);

    _this = _super.call(this, props);

    _this.handleMinutesChange = function (event) {
      var newMinutes = event.target.value;

      _this.setState({
        minutes: newMinutes
      });

      _this.props.onChange("".concat(ordinal(_this.props.reminder), "_after"), newMinutes);
    };

    _this.handleChannelChange = function (event) {
      _this.props.onChange("".concat(ordinal(_this.props.reminder), "_channel"), event.target.value);
    };

    _this.state = {
      minutes: props.minutes
    };
    return _this;
  }

  _createClass(ReminderSetting, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          reminder = _this$props.reminder,
          channel = _this$props.channel;
      var minutes = this.state.minutes;
      return React.createElement("div", {
        className: "row reminder"
      }, React.createElement("div", {
        className: "col-lg-8 col-xl-6 col-xl-offset-1"
      }, React.createElement("div", {
        className: "form-group"
      }, React.createElement("label", {
        className: "col-lg-12 col-xl-10 required"
      }, I18n.t("javascript.reminders_configs.form.".concat(ordinal(reminder), "_after"))), React.createElement("div", {
        className: "col-lg-12 col-xl-10"
      }, React.createElement("div", {
        className: "input-group"
      }, React.createElement("input", {
        className: "form-control",
        type: "number",
        value: minutes,
        onChange: this.handleMinutesChange,
        step: "0.01",
        name: "reminders_config[reminders_settings][".concat(ordinal(reminder), "_after]")
      }), React.createElement("span", {
        className: "input-group-addon"
      }, I18n.t('javascript.reminders_configs.form.minutes')))))), React.createElement("div", {
        className: "col-lg-4 col-xl-4"
      }, React.createElement("div", {
        className: "form-group"
      }, React.createElement("label", {
        className: "col-lg-12 col-xl-12 required"
      }, I18n.t('javascript.reminders_configs.form.channel')), React.createElement("div", {
        className: "col-lg-12 col-xl-12"
      }, React.createElement("select", {
        className: "form-control",
        value: channel,
        onChange: this.handleChannelChange,
        name: "reminders_config[reminders_settings][".concat(ordinal(reminder), "_channel]")
      }, React.createElement("option", {
        value: ""
      }), React.createElement("option", {
        value: "email"
      }, I18n.t('object.attributes.email')), React.createElement("option", {
        value: "sms"
      }, I18n.t('javascript.common.sms')))))));
    }
  }]);

  return ReminderSetting;
}(Component);

ReminderSetting.defaultProps = {
  minutes: ''
};
export default ReminderSetting;